/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_3_3 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [-94.75238499330587, 40.8030480795605],
                        [-94.91992649721212, 40.8030480795605],
                        [-94.91992649721212, 40.68027059275793],
                        [-94.75238499330587, 40.68027059275793],
                        [-94.75238499330587, 40.8030480795605]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_3_3